import { FC } from "react";

interface ConditionalWrapperProps {
    condition: boolean;
    wrapper: (children: React.ReactNode) => JSX.Element;
    children: React.ReactNode;
}

export const ConditionalWrapper: FC<ConditionalWrapperProps> = ({ condition, wrapper, children }) => (condition ? wrapper(children) : <>{children}</>);
